import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { SMS_SENDERS_TABLE_COLUMNS } from '../constants';
import type { SmsSendersTableProps } from '../types';

export const SmsSendersTable = ({ smsSenders }: SmsSendersTableProps) => {
  const {
    currentPage,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: smsSenders,
    sortedBy: 'id',
  });

  return (
    <>
      <Table data-test="senders-authed-sms-table">
        <TableHeader
          columns={SMS_SENDERS_TABLE_COLUMNS}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
          sortDirection={sortDirection}
          sortedBy={sortedBy}
        />
        <TableRows rows={rows} columns={SMS_SENDERS_TABLE_COLUMNS} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};
